const UserInput = ({title,inputRef,value,incorrectValue,type}) => {

  return ( 
    <label htmlFor={value}>

      <h3 className="booking__main__services-title">{title}</h3>

      <input 
        className="booking__main__services-input" 
        ref={inputRef}
        id={value}
        type={type} 
      />
      {incorrectValue!==""?(<p className="incorrect">{incorrectValue}</p>):false}
      
    </label>
   );
}
 
export default UserInput;